export const RUNTIME_OPTIONS = [
  { value: 'TEST_30_DAYS', label: '30-Day Trial' },
  { value: 'ONE_YEAR', label: '1 Year' },
  { value: 'THREE_YEARS', label: '3 Years' },
  { value: 'FIVE_YEARS', label: '5 Years' },
] as const;

export const LICENSE_STATUS_OPTIONS = [
  { value: 'ACTIVE', label: 'Active' },
  { value: 'EXPIRED', label: 'Expired' },
  { value: 'REVOKED', label: 'Revoked' },
  { value: 'SUSPENDED', label: 'Suspended' },
] as const;

export const REQUEST_TYPE_OPTIONS = [
  { value: 'NEW_LICENSE', label: 'New License' },
  { value: 'EXTEND_LICENSE', label: 'Extend License' },
  { value: 'INCREASE_DEVICES', label: 'Increase Devices' },
  { value: 'QUOTATION', label: 'Quotation' },
  { value: 'CHANGE_PARTNER', label: 'Partner wechseln' },
] as const;

export const REQUEST_STATUS_OPTIONS = [
  { value: 'PENDING', label: 'Pending' },
  { value: 'APPROVED', label: 'Approved' },
  { value: 'REJECTED', label: 'Rejected' },
  { value: 'COMPLETED', label: 'Completed' },
] as const;

export const ROLE_OPTIONS = [
  { value: 'ADMIN', label: 'Administrator' },
  { value: 'OWNER', label: 'Owner' },
  { value: 'PARTNER', label: 'Partner' },
  { value: 'INVOICE_TEAM', label: 'Invoice Team' },
  { value: 'CUSTOMER', label: 'Customer' },
] as const;

export const STATUS_COLORS = {
  ACTIVE: 'bg-green-100 text-green-800',
  EXPIRED: 'bg-gray-100 text-gray-800',
  REVOKED: 'bg-red-100 text-red-800',
  SUSPENDED: 'bg-yellow-100 text-yellow-800',
  PENDING: 'bg-yellow-100 text-yellow-800',
  APPROVED: 'bg-green-100 text-green-800',
  REJECTED: 'bg-red-100 text-red-800',
  COMPLETED: 'bg-blue-100 text-blue-800',
} as const;
